import { environment } from 'environments';

(() => {
  angular.module('pims').filter('linkParser', () => {
    return message => {
      let content = message.content; // Attempt to insert a link for any lines using format Visit: #id

      content = content.replace(/visit:\s(\d+)/gim, (match, id) => {
        return `<a href="/visits/${id}">Visit: ${id}</a>`;
      });

      if (!message.links) {
        return { ...message, content };
      }

      let literalLink = '',
        label,
        href;
      message.links.forEach(link => {
        if (link.type === 'couponlink') {
          /*
                    var tag = ":{PRICING_LINK}";
                    link.start = content.indexOf(tag);
                    link.length = tag.length;
                    var details1 = JSON.parse(link.details);
                    literalLink = '';
                    for(var i = 0; i < details1.length; i++){
                      var label1, href1;
                      label1 = details1[i];
                      href1 = details1[i];
                      literalLink += `<a target="_blank" href="${href1}"> ${label1}</a>`;
                    }
                    content = content.splice(link.start, link.length, literalLink);
          */
          var tag = ':{PRICING_LINK}';
          link.start = content.indexOf(tag);
          link.length = tag.length;

          if (link.details.charAt(0) === '[') {
            var details1 = JSON.parse(link.details);
            literalLink = '';

            for (var i = 0; i < details1.length; i++) {
              var label1, href1;
              label1 = details1[i];
              href1 = details1[i];
              literalLink += `<a target="_blank" href="${href1}"> ${label1}</a>`;
            }

            content = content.splice(link.start, link.length, literalLink);
          } else {
            var label2, href2;
            label2 = link.details;
            href2 = link.details;
            literalLink = `<a target="_blank" href="${href2}"> ${label2}</a>`;
            content = content.splice(link.start, link.length, literalLink);
          }
        } else {
          let appHost = 'com.polkadoc.ocp://',
            appPath = 'pages',
            ourHost = '',
            ourPath = 'pages';
          label = content.substring(link.start, link.start + link.length);
          href = link.details; // Replace the mobile app bundle hostname with our host name

          href = href.replace(appHost, ourHost).replace(appPath, ourPath).replace(/\s/g, '_'); // Strip out the last forward slash

          if (href.lastIndexOf('/') === href.length - 1) {
            href = href.substr(0, href.lastIndexOf('/'));
          } // Use relative path for non-http links

          if (href.indexOf('http') === -1) {
            href = `/${href}`;
          }

          literalLink = `<a target="_blank" href="${href}"> ${label}</a>`;
          content = content.splice(link.start, link.length, literalLink);
        } // Splice in the link
        // literalLink = `<a target="_blank" href="${href}"> ${label}</a>`;
        // content = content.splice(link.start, link.length, literalLink);
      });
      return { ...message, content };
    };
  });
})();
